// Portland State University's majors (#2739). Read on 2026-10-01 from the
// official 2026-2027 PSU Bulletin, Programs of Study. The Bulletin is hosted
// off .edu (pdx.smartcatalogiq.com); the source cited is PSU's own PSU
// Bulletin page on pdx.edu (Office of Academic Affairs), which links the
// 2026-2027 Bulletin (Online). Every bachelor's program in the list is here,
// with the degree as the Bulletin writes it (B.A./B.S. where a major offers
// either). The Bulletin lists programs A to Z, not by college. Minors,
// certificates (including pre-baccalaureate and post-baccalaureate
// certificates), the combined B.A. in Applied Linguistics + M.A. in TESOL,
// and graduate programs are left out.
const majors = {
    "slug": "portland-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in Portland State's 2026-2027 Bulletin, with the degree as the Bulletin writes it. Minors and certificates are left out.",
    "groups": [
        {
            "name": "Majors, A to Z",
            "source": {
                "label": "PSU Bulletin 2026-2027, Programs of Study",
                "url": "https://www.pdx.edu/academic-affairs/psu-bulletin"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Applied Health & Fitness",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Applied Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Architecture",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Art & Design",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Art History",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "B.S."
                },
                {
                    "name": "Art Practice",
                    "degree": "B.F.A."
                },
                {
                    "name": "Arts & Letters",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Black Studies",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Business Economics",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Chicanx/Latinx Studies",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Child, Youth, and Family Studies",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Communication",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Community, Urban Studies, and Planning",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Conflict Resolution",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Creative Writing",
                    "degree": "B.F.A."
                },
                {
                    "name": "Criminology and Criminal Justice",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Criminology and Criminal Justice",
                    "degree": "B.A.S."
                },
                {
                    "name": "Cultural History of the Arts",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Earth Science",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Film",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Geography",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Geology",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Graphic Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "History",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Human Services",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Indigenous Nations and Native American Studies",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "International and Global Studies",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Judaic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Liberal Studies",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Linguistics & Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Management & Leadership",
                    "degree": "B.A.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.M."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Public Health Studies",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Quantitative Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Science",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Sexuality, Gender and Queer Studies",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Social Justice and the Arts",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Social Science",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Social Work",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Sonic Arts and Music Production (SAMP)",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Special Education",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Speech and Hearing Sciences",
                    "degree": "B.S./B.A."
                },
                {
                    "name": "Theater Arts",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Urban and Public Affairs",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "Women's Studies",
                    "degree": "B.A./B.S."
                },
                {
                    "name": "World Language",
                    "degree": "B.A.",
                    "note": "Majors in French, German, Japanese, Russian and Spanish."
                }
            ]
        }
    ]
};

export default majors;
